import { useContext, createContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CircleLeftArrow from "../../Components/Icons/CircleLeftArrow";
import CircleRightArrow from "../../Components/Icons/CircleRightArrow";
import { useTranslation } from "react-i18next";
import Settings from "../../Components/Icons/Settings";
import sidelogo from "../../assets/images/logoname.png";
import logo from "../../assets/images/logoo.png";
const SidebarContext = createContext();

export default function SettingsSidebar({ children }) {
  const [expanded, setExpanded] = useState(true);
  const {t,i18n} = useTranslation();

  


  function getExpand() {
    let locExp = localStorage.getItem("settingsExpand");
    if (locExp) {
      setExpanded(JSON.parse(locExp));
    } else {
      localStorage.setItem("settingsExpand", true);
      setExpanded(true);
    }
  }

  useEffect(() => {
    getExpand();
  }, []);

  function toggleExpanded(e) {
    setExpanded(e);
    localStorage.setItem("settingsExpand", e);
  }

  return (
    <aside className={`h-screen bg-white transition-all duration-300 ${
      expanded ? "w-64" : "w-16"
    } fixed left-0 top-0 `}
    onMouseEnter={() => setExpanded(true)}
    onMouseLeave={() => setExpanded(false)}
    >
      <nav className="h-full flex flex-col bg-white border-r shadow-sm">
   <div className="p-4 pb-2 grid grid-cols-8 gap-2">
  <Link to="/dashboard" className="w-10 h-10  mr-1 flex justify-center items-center cursor-pointer">
             <img src={logo} alt="logo" className="object-contain" />

  </Link>

  <Link
    to="/dashboard"
    className={`overflow-hidden col-span-7 font-medium text-xl text-baseColor-primary transition-all cursor-pointer ${
      expanded ? "w-24 ml-4 mt-2" : "w-0"
    }`}
  >
                 <img src={sidelogo} alt="logo" className="object-contain" />

  </Link>
</div>

        <div className=" w-full flex py-1 xl:py-2 px-6 font-medium  my-1 items-center overflow-hidden transition-all text-xs 2xl:text-sm whitespace-nowrap h-8" dir={i18n.language == "ar" ? "rtl" : ""}>
          {expanded ? "Settings :" : <Settings color="black"/>}
        </div>

        <SidebarContext.Provider value={{ expanded }}>
          <ul className="flex-1 px-3 overflow-y-scroll" dir={i18n.language == "ar" ? "rtl" : ""}>{children}</ul>
        </SidebarContext.Provider>
        
        <div className=" w-full px-2">
          <p className={`font-normal text-left text-[9px] text-slate-400`}>
            <a href="https://numota.in" target="_blank">
             &#169; numota
            </a>
          </p>
        </div>
      </nav>
    </aside>
  );
}

export function SettingsSidebarItem({ icon, text, active, alert, link }) {
  const { expanded } = useContext(SidebarContext);
  const {t,i18n} = useTranslation();


  return (
    <li
      className={`
        relative flex items-center py-1 xl:py-2 px-2 my-1
        font-medium rounded-md cursor-pointer
        transition-colors group whitespace-nowrap
        ${
          active==true
            ? "bg-gradient-to-tr from-red-200 to-red-100 text-red-800"
            : "hover:bg-red-50 text-gray-600"
        }
    `}
    >
      <Link to={link}>
        <span className=" w-4 h-4 text-xs 2xl:text-sm">{icon}</span>
      </Link>

      <span
        className={`overflow-hidden transition-all text-xs ${
          expanded ?`w-28 xl:w-32 ${i18n.language == "ar" ? "mr-3":"ml-3"} `  : "w-0"
        }`}
      >
        <Link to={link}>{text}</Link>
      </span>
      {alert && (
        <div
          className={`absolute right-2 w-2 h-2 rounded bg-red-400 ${
            expanded ? "" : "top-2"
          }`}
        />
      )}

    </li>
  );
}
